import TabelaHeaderInputs from "./TabelaHeaderInputs";

export default function TabelaHeader({ filtro, setFiltro }) {
  return (
    <thead className="bg-[#2b2b2b]">
      <tr>
        <TabelaHeaderInputs filtro={filtro} setFiltro={setFiltro} />

        {/* Ações */}
        <th className="w-[4%] px-2 py-4 text-center text-sm font-semibold text-white border border-slate-400">
          Ações
        </th>
      </tr>
    </thead>
  );
}
